import * as React from 'react'

import { ILinkedItem } from './ResourceLinkContext'

interface IResult {
  openedLinkedRecordId: string | null
  openLinkedRecord: () => void
  closeLinkedRecord: () => void
}

export function useLinkedResourceEditor(
  linkedItem: ILinkedItem | null,
): IResult {
  const [openedLinkedRecordId, setOpenedLinkedRecordId] = React.useState<
    string | null
  >(null)

  React.useEffect(() => {
    if (!linkedItem && openedLinkedRecordId) {
      setOpenedLinkedRecordId(null)
    }
  }, [linkedItem, openedLinkedRecordId])

  const openLinkedRecord = React.useCallback(() => {
    if (linkedItem?.id) {
      setOpenedLinkedRecordId(linkedItem.id)
    }
  }, [linkedItem])

  const closeLinkedRecord = React.useCallback(() => {
    setOpenedLinkedRecordId(null)
  }, [])

  return {
    openedLinkedRecordId,
    openLinkedRecord,
    closeLinkedRecord,
  }
}
